const Home = () => {
  return (
    <div className="home">
      <h1 className="heading">
        HELLO, I'M <br />
        <strong> LAMBE BOLUWATIFE</strong>
      </h1>
      <h6>
        I AM A <strong>FULLSTACK DEVELOPER</strong> FROM NIGERIA. <br /> I{" "}
        <strong>THINK</strong>, I <strong>BUILD</strong>, AND{" "}
        <strong>I BRING IDEAS TO LIFE THROUGH CODE</strong>. <br /> FROM
        <strong> DYNAMIC FRONTENDS TO POWERFUL BACKENDS</strong>. <br />
        I CREATE MODERN, USER-CENTERED WEB EXPERIENCES.
        <br /> <strong>WELCOME TO MY PORTFOLIO.</strong>
      </h6>

      <a href="/portfolio">See How I Build</a>
    </div>
  );
};

export default Home;
